<template>
  <router-view />
</template>

<script>
// Styles
  import '@/styles/overrides.sass'

  export default {
    name: 'App',

    metaInfo: {
      titleTemplate: '%s',
      htmlAttrs: { lang: 'pt-BR' },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      ],
    },
  }
</script>

<style>
html {
  scroll-behavior: smooth;
}
/* #app {
  background: url("./assets/login.jpg") no-repeat center center fixed !important;
  background-size: cover;
} */
.v-data-table-header-mobile {
  display: none !important;
}
.text-green input {
  color: green !important;
}
.text-red input {
  color: red !important;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus textarea:-webkit-autofill,
textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-background-clip: text;
  /* -webkit-text-fill-color: white !important; */
}
</style>
